export const debounce = (delay: number, fn: (args: any) => any) => {
  let inDebounce: any;
  return (...args: any[]) => {
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => fn(args), delay);
  }
}